// src/About.js
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const About = () => {
  const [showContent, setShowContent] = useState(true); // slide-in on mount

  const headingText = "💼 About InvestorLanes";

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-r from-blue-100 via-purple-100 to-pink-100 p-6 relative overflow-hidden">
      
      {/* Background sparkles ✨ */}
      {Array.from({ length: 20 }).map((_, i) => {
        const size = Math.random() * 2 + 1;
        const duration = 3 + Math.random() * 4;
        const delay = Math.random() * 5;
        const top = Math.random() * 100;
        const left = Math.random() * 100;
        return (
          <div
            key={i}
            className="absolute rounded-full bg-yellow-300"
            style={{
              width: `${size}px`,
              height: `${size}px`,
              top: `${top}%`,
              left: `${left}%`,
              opacity: 0.7,
              animation: `twinkle ${duration}s ease-in-out ${delay}s infinite alternate`,
              boxShadow: "0 0 4px rgba(255, 215, 0, 0.7)",
            }}
          />
        );
      })}

      <AnimatePresence>
        {showContent && (
          <motion.section
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
            transition={{ duration: 0.8, ease: "easeInOut" }}
            className="max-w-4xl bg-white/80 backdrop-blur-md rounded-3xl p-8 shadow-lg border border-white/30 relative"
            style={{
              boxShadow:
                "0 0 20px rgba(255, 255, 255, 0.2), 0 0 60px rgba(255, 255, 255, 0.1)",
            }}
          >
            {/* ✨ Heading with sparkling letters */}
            <motion.h2
              className="text-4xl font-bold text-center mb-6 cursor-pointer relative inline-block"
            >
              {headingText.split("").map((char, index) => (
                <span key={index} className="relative inline-block heading-letter">
                  {char}
                  <span className="absolute inset-0 pointer-events-none">
                    {Array.from({ length: 2 }).map((_, i) => {
                      const size = Math.random() * 2 + 1;
                      const top = Math.random() * 100;
                      const left = Math.random() * 100;
                      return (
                        <span
                          key={i}
                          className="absolute bg-yellow-300 rounded-full opacity-0 animate-letter-twinkle"
                          style={{
                            width: `${size}px`,
                            height: `${size}px`,
                            top: `${top}%`,
                            left: `${left}%`,
                            boxShadow: "0 0 6px rgba(255, 215, 0, 0.9)",
                          }}
                        />
                      );
                    })}
                  </span>
                </span>
              ))}
            </motion.h2>

            {/* Paragraphs with hover sparkle effect */}
            {[
              "InvestorLanes is Africa’s premier investor-entrepreneur matchmaking platform. We empower visionary entrepreneurs to connect with verified, active angel investors and private investors, including but not limited to individuals seeking investment opportunities across different industries such as fintech,finance,healthtech,insurance,agritech,manufacturing,real estate,media,e-commerce,renewable energy and more,just you name it,we have it for you.",
              "Our intelligent algorithm ranks investors based on relevance, location, and funding interests, giving entrepreneurs the highest chances of success. We ensure a transparent, secure, and fair environment for deal-making — driven by data, powered by AI.",
              "Whether you’re just  a startup founder looking for funding, or a big business in trouble,facing bankruptcy or declared insolvent,or simple growth and scaling; we have your back. You are an investor scouting your next venture, InvestorLanes simplifies the connection process — one verified profile at a time - Lane by Lane,choose your lane and keep it moving."
            ].map((text, index) => (
              <motion.p
                key={index}
                className="text-gray-700 leading-relaxed mb-4 relative cursor-pointer"
                whileHover={{ scale: 1.02 }}
              >
                {text}
                {/* Paragraph sparkles */}
                <span className="absolute inset-0 pointer-events-none">
                  {Array.from({ length: 5 }).map((_, i) => {
                    const size = Math.random() * 2 + 1;
                    const top = Math.random() * 100;
                    const left = Math.random() * 100;
                    return (
                      <span
                        key={i}
                        className="absolute bg-yellow-300 rounded-full opacity-0 animate-hover-twinkle"
                        style={{
                          width: `${size}px`,
                          height: `${size}px`,
                          top: `${top}%`,
                          left: `${left}%`,
                          boxShadow: "0 0 6px rgba(255, 215, 0, 0.9)",
                        }}
                      />
                    );
                  })}
                </span>
              </motion.p>
            ))}
          </motion.section>
        )}
      </AnimatePresence>

      <style>
        {`
          @keyframes twinkle {
            0% { opacity: 0.3; transform: scale(0.5); }
            50% { opacity: 1; transform: scale(1); }
            100% { opacity: 0.3; transform: scale(0.5); }
          }

          @keyframes hover-twinkle {
            0% { opacity: 0; transform: scale(0.5); }
            50% { opacity: 1; transform: scale(1.2); }
            100% { opacity: 0; transform: scale(0.5); }
          }

          @keyframes letter-twinkle {
            0% { opacity: 0; transform: scale(0.5); }
            50% { opacity: 1; transform: scale(1.3); }
            100% { opacity: 0; transform: scale(0.5); }
          }

          .animate-hover-twinkle {
            animation: hover-twinkle 0.8s ease-in-out infinite;
          }

          .animate-letter-twinkle {
            animation: letter-twinkle 0.6s ease-in-out infinite;
          }

          p:hover .animate-hover-twinkle {
            opacity: 1;
          }

          .heading-letter:hover .animate-letter-twinkle {
            opacity: 1;
          }
        `}
      </style>
    </div>
  );
};

export default About;
